






































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { TransceiversApi } from '../../../api';
import Toast from '@/components/display/toast.vue';
import TitleMixin from '@/mixins/title-mixin';
import RouterLinkButton from '@/components/elements/buttons/router-link-button.vue';
import infoTabs from '@/layouts/parent/BTabsParent.vue';
import rebootTransceiver from '@/components/elements/functional buttons/reboot-transceiver.vue';
import TransceiverReceivedTsChartSeries from '@/components/charts/transceiver-received-ts-chart.vue';
import TransceiverUdpPacketChart from '@/components/charts/transceiver-udp-packet-chart.vue';
import AdminChart from '@/components/charts/admin-chart.vue';
import TreeView from '@/components/display/tree.vue';
import AddUpdateEntityLocation from '@/components/add business objects/addUpdateEntityLocation.vue';
import ThingGroupRow from '@/components/display/information-rows/thing-group-row.vue';
import StatusRow from '@/components/display/information-rows/status-row.vue';
import ChangelogLink from '@/components/display/changelog-link.vue';
import EntityChargingBehaviourChart from '@/components/charts/entity-charging-behaviour-chart.vue';
import EntityBatteryChart from '@/components/charts/entity-battery-chart.vue';
import SetTransceiverDeploymentMode from '@/components/elements/functional buttons/set-transceiver-deployment-mode.vue';
import RemoveGatewayFromSite from '@/components/elements/functional buttons/remove-gateway-from-site.vue';
import { getApnDisplayName } from '@/common/SimApnUtil';
import RawData from '@/components/display/raw-data/raw-data.vue';
@Component({
	components: {
		RawData,
		SetTransceiverDeploymentMode,
		RemoveGatewayFromSite,
		EntityBatteryChart,
		EntityChargingBehaviourChart,
		ChangelogLink,
		StatusRow,
		ThingGroupRow,
		RouterLinkButton,
		secondaryNav,
		Toast,
		infoTabs,
		rebootTransceiver,
		TransceiverReceivedTsChartSeries,
		TransceiverUdpPacketChart,
		AdminChart,
		TreeView,
		AddUpdateEntityLocation,
	},
	mixins: [TitleMixin],
	methods: { getApnDisplayName },
})
export default class TransceiverView extends Vue {
	public checkInTime = null;
	public smallScreen = window.innerWidth > 1000;
	public tabIndex = 1;
	public loading = true;
	public transceiver: any | null = null;
	public transceiverEntityType = null;
	public site: any | null = null;
	public vats: any[] | null = null;
	public products: any[] | null = null;
	public audits: any[] | null = null;
	public fields: any[] | null = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];
	public parentLocations = [];
	public generalInfo = [];
	public dash: any[] | null = [];
	private api: TransceiversApi = new TransceiversApi();

	public pageTitle() {
		return `Transceiver | ${this.transceiver ? this.transceiver.serialNumber : ''}`;
	}

	public async load() {
		const { transceiverId } = this.$route.params;
		this.loading = true;
		try {
			const { data } = await this.api.getTransceiverById(parseInt(transceiverId, 10), {
				params: {
					include:
						'audits,' +
						'audits.user,' +
						'entitylocation,' +
						'gateway.entitylocation,' +
						'nodes.entitylocation,' +
						'nodes.sensors,' +
						'nodes.sensors.owner.product,' +
						'nodes.sensors.vat.product,' +
						'nodes.sensors.tank.product,' +
						'products,' +
						'site,' +
						'sensors,' +
						'sensors.owner.product,' +
						'sensors.vat.product,' +
						'sensors.tank.product,' +
						'vats,' +
						'simcard',
				},
			});
			this.transceiver = data;
			this.vats = data.vats || {};
			this.site = data.site || {};
			this.products = data.products || {};
			this.audits = data.audits || {};

			if (
				this.transceiver.type === '01' ||
				this.transceiver.type === '02' ||
				this.transceiver.type === '03' ||
				this.transceiver.type === '04'
			) {
				this.transceiverEntityType = 'tank';
				this.loadDash();
				this.generalInfo = [
					{ text: 'Serial Number', value: this.transceiver.serialNumber || '' },
					{ text: 'Imei', value: this.transceiver.imei || '' },
					{ text: 'Sim Iccid', value: this.transceiver.simIccid || '' },
					{ text: 'Batch Number', value: this.transceiver.batchNumber || '' },
					{ text: 'Voltage', value: this.dash.batteryVoltage || '' },
					{ text: 'Cell Strength', value: this.dash.cellStrength || '' },
					{ text: 'Bootloader Version', value: this.transceiver.bootloaderVersion || '' },
					{
						text: 'Bridge Config',
						value: this.transceiver.bridgeConfig ? this.transceiver.bridgeConfig.bridge : '',
					},
					{ text: 'Type', value: this.transceiver.type || '' },
				];
			} else {
				this.transceiverEntityType = 'vat';
				this.generalInfo = [
					{ text: 'Thing Id', value: this.transceiver.thingId || '' },
					{ text: 'Aws Principal Id', value: this.transceiver.principalId || '' },
					{ text: 'Firmware Version', value: this.transceiver.firmwareVersion || '' },
					{ text: 'Thing Group', value: this.transceiver.thingGroupName || '' },
					{ text: 'Mb Version', value: this.transceiver.mbVersion || '' },
					{ text: 'Po Number', value: this.transceiver.poNumber || '' },
					{ text: 'Serial Number', value: this.transceiver.serialNumber || '' },
					{ text: 'Imei', value: this.transceiver.imei || '' },
					{ text: 'Sb Version', value: this.transceiver.sbVersion || '' },
					{ text: 'Sim Iicid', value: this.transceiver.simIccid || '' },
					{ text: 'Bootloader Version', value: this.transceiver.bootloaderVersion || '' },
					{ text: 'Eb Version', value: this.transceiver.ebVersion || '' },
					{ text: 'Type', value: this.transceiver.type || '' },
				];
			}
			this.parentLocations = [];
			if (this.transceiver.gateway && this.transceiver.gateway.entitylocation) {
				this.parentLocations.push({
					type: 'Gateway',
					latitude: this.transceiver.gateway.entitylocation.latitude,
					longitude: this.transceiver.gateway.entitylocation.longitude,
				});
			}
			if (this.transceiver.site && this.transceiver.site.latitude) {
				this.parentLocations.push({
					type: 'Site',
					latitude: this.transceiver.site.latitude,
					longitude: this.transceiver.site.longitude,
				});
				if (this.transceiver.entitylocation === null) {
					this.transceiver.entitylocation = {
						id: null,
						entityId: this.transceiver.id,
						entityType: 'transceivers',
						latitude: null,
						longitude: null,
						notes: null,
					};
				}
			}
		} catch (e) {
			console.log(e);
			this.transceiver = null;
		} finally {
			this.loading = false;
		}
	}

	// fuel transceivers only
	public async loadDash() {
		const { transceiverId } = this.$route.params;
		const api = new TransceiversApi();
		const response = await api.getTransceiverDash(parseInt(transceiverId, 10));
		this.dash = response.data.data;
	}

	public created() {
		this.load();
	}
}
